import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPayrollInstructions = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "PayrollInstructionsFlowContainer" */
                '@perpay-web/fintech/components/containers/PayrollInstructionsFlowContainer'
            ),
    );
